import {PlainDtoModel} from "../../../../../../../common/entity/dto/plain/plainDto.model";
import {LovValueSummary} from "../../../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class TreatmentJourneyStepDefinitionTriggerModel implements PlainDtoModel {
    type: LovValueSummary;
    nbDays: number;
    stepDefinitionId: number;

}